const quickViewWarpper = document.getElementById("quickViewWrapper");
let quickViewRequest = 0;
let quickViewOpener;

function closeQuickView() {
  ++quickViewRequest;
  if (!quickViewWarpper.classList.contains("show__modal")) return;
  document.body.classList.remove("overflow-hidden");
  quickViewWarpper.classList.remove("show__modal");
  quickViewOpener?.classList.remove("active");
  removeTrapFocus(quickViewOpener);
}

quickViewWarpper.addEventListener("keydown", (event) => {
  if (event.key === "Escape") closeQuickView();
});
quickViewWarpper.addEventListener("click", (event) => {
  if (!event.target.closest(".quick_view__body")) closeQuickView();
});

class quickViewModal extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", this.onClickQuickViewModal);
  }

  onClickQuickViewModal = async () => {
    const opener = this.querySelector("button");
    const request = ++quickViewRequest;
    opener.classList.add("loading");
    this.querySelector(".quick-view-error")?.remove();
    try {
      const response = await fetch(`/products/${opener.dataset.productHandle}?view=quickview`);
      if (!response.ok) throw new Error(`Quick View failed: ${response.status}`);
      const text = await response.text();
      if (request !== quickViewRequest) return;
      const html = new DOMParser().parseFromString(text, "text/html");
      if (!html.querySelector(".quick_view__body quick-view-close button") || !html.querySelector(".product__title")) throw new Error("Quick View content missing");
      quickViewWarpper.innerHTML = text;
      if (window.Shopify && Shopify.PaymentButton) Shopify.PaymentButton.init();
      quickViewOpener = opener;
      document.body.classList.add("overflow-hidden");
      quickViewWarpper.classList.add("show__modal");
      opener.classList.add("active");
      const dialog = quickViewWarpper.querySelector(".quick_view__body");
      dialog.setAttribute("role", "dialog");
      dialog.setAttribute("aria-modal", "true");
      dialog.setAttribute("aria-label", html.querySelector(".product__title").textContent);
      trapFocus(dialog, dialog.querySelector("quick-view-close button"));
    } catch (error) {
      if (request !== quickViewRequest) return;
      console.error(error);
      const message = document.createElement("p");
      message.className = "quick-view-error";
      message.setAttribute("role", "alert");
      message.append("Could not load Quick View. Try again or ");
      const link = document.createElement("a");
      link.href = `/products/${opener.dataset.productHandle}`;
      link.textContent = "view product";
      message.append(link);
      this.append(message);
    } finally {
      opener.classList.remove("loading");
    }
  };
}
customElements.define("quick-view-modal", quickViewModal);

class quickViewCloseTag extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", closeQuickView);
  }
}
customElements.define("quick-view-close", quickViewCloseTag);

class QuickVariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange() {
    this.variantRequest = (this.variantRequest || 0) + 1;
    this.updateOptions();
    this.updateOptionsParent();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.getPreOrderVariantData();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateVariantInput();
      this.renderProductInfo();
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateOptionsParent() {
    Array.from(this.querySelectorAll(".product-form__input--dropdown")).map(
      (select, index) => {
        select.children[0].children[1].innerHTML = this.options[index];
      }
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );
    if (!newMedia) return;
    const parent = newMedia.parentElement;
    if (parent.firstChild == newMedia) return;
    parent.prepend(newMedia);
    window.setTimeout(() => {
      parent.scroll(0, 0);
    });
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  renderProductInfo() {
    const request = this.variantRequest;
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (price) price.classList.add("no-js-inline");
    this.querySelector(".variant-request-error")?.remove();
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then((response) => {
        if (!response.ok) throw new Error(`Variant request failed: ${response.status}`);
        return response.text();
      })
      .then((responseText) => {
        if (request !== this.variantRequest || !this.isConnected) return;
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(id);
        //console.log(destination);
        const source = html.getElementById(id);
        if (!source || !destination) throw new Error("Variant price missing");
        destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove("no-js-inline");
        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.soldOut
        );
      })
      .catch((error) => {
        if (request !== this.variantRequest || !this.isConnected) return;
        console.error(error);
        this.toggleAddButton(true, "", false);
        const message = document.createElement("p");
        message.className = "variant-request-error";
        message.setAttribute("role", "alert");
        message.append("Could not load this option’s price. ");
        const retry = document.createElement("button");
        retry.type = "button";
        retry.className = "link";
        retry.textContent = "Retry";
        retry.addEventListener("click", () => this.renderProductInfo());
        message.append(retry);
        this.append(message);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    //console.log(this.PreorderVariantData);

    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');

    if (!addButton) return;
    if (disable) {
      addButton.setAttribute("disabled", true);
      if (text) addButton.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      addButton.textContent = window.variantStrings.addToCart;
    }

    if (disable) return;

    // Preorder Button
    let productVarArray = this.PreorderVariantData;
    let variant = this.currentVariant;
    let VarInventoryManagement =
      this.currentVariant?.inventory_management ?? null;
    let var_num = "";
    if (VarInventoryManagement != null) {
      for (let variant_id in productVarArray) {
        if (variant.id == variant_id) {
          var_num = productVarArray[variant_id].qty;
          var inventoryQuantity = parseInt(var_num);
          var inventoryPolicy = productVarArray[variant_id].inventory_policy;
        }
        if (inventoryQuantity <= 0 && inventoryPolicy === "continue") {
          addButton.removeAttribute("disabled");
          addButton.textContent = window.variantStrings.preorder;
        } else if (inventoryQuantity <= 0 && inventoryPolicy !== "continue") {
          addButton.setAttribute("disabled", true);
          addButton.textContent = window.variantStrings.soldOut;
        } else {
          addButton.removeAttribute("disabled");
          addButton.textContent = window.variantStrings.addToCart;
        }
      }
    }
    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButton.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("no-js-inline");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector("[data-variant]").textContent);
    return this.variantData;
  }
  getPreOrderVariantData() {
    this.PreorderVariantData =
      this.PreorderVariantData ||
      JSON.parse(this.querySelector("[data-preorder]").textContent);
  }
}

customElements.define("quick-variant-selects", QuickVariantSelects);

class QuickVariantRadios extends QuickVariantSelects {
  constructor() {
    super();
    this.fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.onColorSwatches();
  }

  onColorSwatches() {
    const swatchButtonList = this.querySelectorAll(
      `fieldset.variant--swatch-${this.dataset.colorSwatch} > label`
    );
    const result = Object.values(
      this.getVariantData().reduce((total, item) => {
        let k = `${item[this.dataset.colorSwatch]}`;
        if (!total[k]) {
          total[k] = { ...item, count: 1 };
        } else {
          total[k].count += 1;
        }
        return total;
      }, {})
    );
    swatchButtonList.forEach((button) => {
      result.forEach((data) => {
        if (data[this.dataset.colorSwatch] === button.dataset.value) {
          if (
            this.dataset.colorSwatchStyle === "image" &&
            data.featured_image !== null
          ) {
            button.setAttribute(
              "style",
              `--swatch-background-image: url(${
                data.featured_image.src
              }); --swatch-background-color: ${data[this.dataset.colorSwatch]};`
            );
          } else {
            button.setAttribute(
              "style",
              `--swatch-background-color: ${data[this.dataset.colorSwatch]};`
            );
          }
        }
      });
    });
  }

  updateOptions() {
    this.options = this.fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }

  updateOptionsParent() {
    this.fieldsets.map((fieldset, index) => {
      fieldset.children[0].children[1].innerHTML = this.options[index];
    });
  }
}
customElements.define("quick-variant-radios", QuickVariantRadios);
